import { Box } from "@mui/material"
import Header from "./components/Header.tsx"
import { Outlet } from "react-router-dom"
import { Suspense, useState } from "react"
import Sidebar from "./components/Sidebar/Sidebar.tsx"
import GeneralSuspenseFallback from "../GeneralSuspenseFallback.tsx"
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary.tsx"
import ConnectionStatus from "./components/ConnectionStatus/ConnectionStatus.tsx"
import { SAFE_AREA_INSET_LEFT, SAFE_AREA_INSET_RIGHT } from "./shared/safeArea.ts"

export default function Layout() {
  const [isSideBarOpen, setIsSideBarOpen] = useState(false)

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        paddingLeft: SAFE_AREA_INSET_LEFT,
        paddingRight: SAFE_AREA_INSET_RIGHT,
      }}
    >
      <Header key={"AppHeader"} setOpenSidebar={setIsSideBarOpen} />
      <Sidebar key={"AppSidebar"} openSidebar={isSideBarOpen} setOpenSidebar={setIsSideBarOpen} />

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Suspense fallback={<GeneralSuspenseFallback />} key={location.pathname}>
          <ErrorBoundary key={"MainErrorBoundary"} displayMsg>
            <Outlet />
          </ErrorBoundary>
        </Suspense>
      </Box>

      <ConnectionStatus />
    </Box>
  )
}
